/* eslint-disable camelcase */
import { Stack } from "@mui/material";
import React from "react";

import { NotesSection } from "components/detector/NotesModal/NotesContent/NotesSection/NotesSection";
import { LocalNotes, NoteOwner } from "types/notes";

export interface LocalNotesContentProps {
  notesData: LocalNotes;
  setNotesData: React.Dispatch<React.SetStateAction<LocalNotes>>;
}

export function LocalNotesContent(props: LocalNotesContentProps) {
  const { notesData, setNotesData } = props;

  return (
    <Stack className="gap-4">
      <NotesSection
        notesData={notesData.CUSTOMER}
        isLocalModeActive
        setNotesData={setNotesData}
        ownerNote={NoteOwner.CUSTOMER}
        isLoadingNotes={false}
      />
    </Stack>
  );
}
